import qs from "query-string";

export function paramify(paramObject) {
  return qs.stringify(
    _.omit(paramObject, (value) => isEmptyQueryValue(value)),
    { arrayFormat: "repeat", delimiter: "&" }
  );
}
